<template>
  <el-dialog title="光照控制" :visible.sync="show" width="60%">
    <div style="height: 360px">
      <el-alert type="success" :closable="false">
        闷棚（土壤处理）期，光照控制无要求，建议停止所有遮光措施。
        基于模型的自动控制请至“综合营养”板块查看
      </el-alert>
      <el-row class="mt-3">
        <el-col span="6">
          <h5>实时光照强度</h5>
          <p>38624 <span class="font-size:12px">Lux</span></p>

          <h5>日光合辐照累积量</h5>
          <p>--</p>

          <h5>月光合辐照累积量</h5>
          <p>--</p>
        </el-col>
        <el-col span="6">
          <h5>光照强度建议范围</h5>
          <p>--</p>

          <h5>建议日光合辐照累积量</h5>
          <p>--</p>

          <h5>建议月光合辐照累积量</h5>
          <p>--</p>
        </el-col>
        <el-col span="12">
          <h5>建议</h5>
          <p>此阶段无建议</p>

          <h5>遮阳</h5>
          <p>
            <el-button-group>
              <el-button type="primary" :disabled="true" size="small">
                关闭
              </el-button>
              <el-button type="primary" :disabled="true" size="small">
                自动
              </el-button>
              <el-button type="primary" :disabled="true" size="small">
                打开
              </el-button>
            </el-button-group>
          </p>

          <h5>补光</h5>
          <p>
            <el-button-group>
              <el-button type="primary" :disabled="true" size="small">
                关闭
              </el-button>
              <el-button type="primary" :disabled="true" size="small">
                自动
              </el-button>
              <el-button type="primary" :disabled="true" size="small">
                打开
              </el-button>
            </el-button-group>
          </p>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    }
  },
  methods: {
    open() {
      this.show = true
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/welcome/LandGuideLightDialog.vue